
// Task section 16: "Objekttyper skal filtreres ud fra: aktiv DANVA-model,
// geometri, eventuelle modelkrav... En LineString skal ikke tilbyde
// irrelevante punkttyper... Denne kompatibilitet skal baseres på de
// officielle modeldefinitioner, hvor det er muligt." Pure/Level-1: reads
// only the ModelProvider's own `geometryTypes` per object type (see
// DanvaModelProvider.js's documented ModelDefinition contract) against a
// feature's `geometry.type` - never a hardcoded per-tool if/else table
// (task section 10's own explicit anti-pattern).
export function listCompatibleObjectTypes(modelProvider, model, version, geometryType){
	const objectTypes = modelProvider.getObjectTypes(model, version);
	return objectTypes.filter((t) => t.geometryTypes.includes(geometryType));
}

export function isObjectTypeCompatible(modelProvider, model, version, objectTypeId, geometryType){
	const def = modelProvider.getObjectDefinition(model, version, objectTypeId);
	return !!(def && def.geometryTypes.includes(geometryType));
}
